import React, { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import './LanguageCentersPage.css';

const LanguageCentersPage = () => {
  const [centers, setCenters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCenters();
  }, []);

  const fetchCenters = async () => {
    try {
      const response = await apiClient.get('/api/sprogcentre');
      setCenters(response.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // Hjælper til at vise prøver
  const renderExams = (sc) => {
    const exams = [
      { key: 'udbyder_pd1', label: 'PD1' },
      { key: 'udbyder_pd2', label: 'PD2' },
      { key: 'udbyder_pd3', label: 'PD3' },
      { key: 'udbyder_sp', label: 'SP' },
    ];
    return exams.map(exam => (
      <span key={exam.key} className={`exam-badge ${sc[exam.key] ? 'active' : ''}`}>
        {exam.label}
      </span>
    ));
  };

  return (
    <div>
      <div className="table-card">
        {loading ? <p>Henter data...</p> : (
          <table className="sc-table">
            <thead>
              <tr>
                <th>Sprogcenter</th>
                <th>Organisation</th>
                <th>Kontakt</th>
                <th>Udbud</th>
                <th style={{textAlign:'right'}}>Handling</th>
              </tr>
            </thead>
            <tbody>
              {centers.map(sc => (
                <tr key={sc.id}>
                  <td>
                    <div style={{fontWeight: 'bold', color: '#003366'}}>{sc.navn}</div>
                    <div style={{fontSize: '0.85rem', color: '#666'}}>
                      {sc.adresse}, {sc.postnummer} {sc.forstad}
                    </div>
                  </td>
                  <td>{sc.organisations_navn || '-'}</td>
                  <td>
                    <div style={{fontSize: '0.9rem'}}>{sc.email}</div>
                    <div style={{fontSize: '0.8rem', color: '#888'}}>{sc.telefon}</div>
                  </td>
                  <td>{renderExams(sc)}</td>
                  <td style={{textAlign:'right'}}>
                    <button style={{background:'none', border:'1px solid #ddd', padding:'5px 10px', borderRadius:'4px', cursor:'pointer'}}>
                      Rediger
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default LanguageCentersPage;